<div class="container-fluid page">
  <div class="d-flex align-items-center mb-3" style="gap: 20px">
    <span class="go-back" [attr.aria-hidden]="true" (click)="redirectTo()">
      <img src="assets/images/arrow-left.svg" alt="" />Currency Conversion Rate
    </span>
    <img src="assets/images/arrow-right.svg" alt="" />
    <ng-container *ngIf="!isEdit">New</ng-container>
    <ng-container *ngIf="isEdit">Edit</ng-container>
    Conversion Rate
  </div>
  <form class="mat-form" [formGroup]="upsertConversationRateForm">
    <div class="row mt-2">
      <div class="col-12">
        <mat-card>
          <div class="row">
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onSourceCountryChange($event)"
                [inputData]="attrConstant.srcCountry"
                [selectOptions]="sourceCountryList"
                [bindLabel]="'countryName'"
                [bindValue]="'countryCode'"
                [formControlName]="
                  attrConstant.srcCountry.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                (selectionChange)="onDestCountryChange($event)"
                [inputData]="attrConstant.destCountry"
                [selectOptions]="destCountryList"
                [bindLabel]="'countryName'"
                [bindValue]="'countryCode'"
                [formControlName]="
                  attrConstant.destCountry.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.sourceCurrency"
                [formControlName]="
                  attrConstant.sourceCurrency.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.destinationCurrency"
                [formControlName]="
                  attrConstant.destinationCurrency.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.transferType"
                [selectOptions]="transactionSettings?.transfer_types ?? []"
                [bindLabel]="'name'"
                [bindValue]="'value'"
                [formControlName]="
                  attrConstant.transferType.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.serviceLevel"
                [selectOptions]="
                  transactionSettings?.service_level_delivery_speed_codes ?? []
                "
                [bindLabel]="'name'"
                [bindValue]="'code'"
                [formControlName]="
                  attrConstant.serviceLevel.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-select
                [inputData]="attrConstant.paymentType"
                [selectOptions]="
                  transactionSettings?.payment_method_codes ?? []
                "
                [bindLabel]="'name'"
                [bindValue]="'imgPath'"
                [formControlName]="
                  attrConstant.paymentType.key
                "></app-input-select>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.otherFee"
                [formControlName]="
                  attrConstant.otherFee.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                (input)="onKeyUp()"
                [inputData]="attrConstant.sellRate"
                [formControlName]="
                  attrConstant.sellRate.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                (input)="onKeyUp()"
                [inputData]="attrConstant.markupPercentage"
                [formControlName]="
                  attrConstant.markupPercentage.key
                "></app-input-template>
            </div>
            <div class="col-md-6 form-group">
              <app-input-template
                [inputData]="attrConstant.masterRate"
                [formControlName]="
                  attrConstant.masterRate.key
                "></app-input-template>
            </div>
            <mat-card class="mx-2">
              <mat-card-title class="h4">Platform Fee</mat-card-title>
              <mat-divider></mat-divider>
              <div formArrayName="platform_fee">
                <div *ngFor="let data of formArrayData.controls; let i = index">
                  <div [formGroupName]="i" class="row mt-3">
                    <div class="col-md-6 form-group">
                      <app-input-template
                        [inputData]="attrConstant.slabAmount"
                        [formControlName]="
                          attrConstant.slabAmount.key
                        "></app-input-template>
                    </div>
                    <div class="col-md-6 form-group">
                      <app-input-template
                        [inputData]="attrConstant.fixedFee"
                        [formControlName]="
                          attrConstant.fixedFee.key
                        "></app-input-template>
                    </div>
                    <div class="col-md-6 form-group">
                      <app-input-template
                        [inputData]="attrConstant.percentageFee"
                        [formControlName]="
                          attrConstant.percentageFee.key
                        "></app-input-template>
                    </div>
                    <div class="col-md-6 form-group">
                      <mat-checkbox
                        [formControlName]="attrConstant.useFixedFee.key">
                        Use Fixed Fee
                      </mat-checkbox>
                    </div>
                    <div class="col-12 text-end mt-2">
                      <a
                        class="primary-btn text-decoration-none cursor-pointer"
                        [attr.aria-hidden]="true"
                        (click)="addPlatformFee()">
                        Add New
                      </a>
                      <a
                        *ngIf="formArrayData.controls.length > 1"
                        class="primary-btn text-decoration-none cursor-pointer ms-3"
                        [attr.aria-hidden]="true"
                        (click)="removePlatformFee(i)">
                        Remove
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </mat-card>
          </div>
        </mat-card>
      </div>
    </div>
    <button
      class="btn primary-btn w-100 mt-3"
      (click)="upsertConversationRateSubmit()">
      Submit
    </button>
  </form>
</div>
